/* global axios */

import ApiClient from './ApiClient';

const flowsClient = new ApiClient('flows', {
  accountScoped: true,
});
const flowSessionsClient = new ApiClient('flow_sessions', {
  accountScoped: true,
});

export const flowsAPI = {
  list({ language, category, active } = {}) {
    return axios.get(flowsClient.url, {
      params: { language, category, active },
    });
  },

  get(id) {
    return axios.get(`${flowsClient.url}/${id}`);
  },

  create(data) {
    return axios.post(flowsClient.url, { flow: data });
  },

  update(id, data) {
    return axios.put(`${flowsClient.url}/${id}`, { flow: data });
  },

  delete(id) {
    return axios.delete(`${flowsClient.url}/${id}`);
  },

  trigger(flowId, conversationId) {
    return axios.post(`${flowsClient.url}/${flowId}/trigger`, {
      conversation_id: conversationId,
    });
  },
};

export const flowSessionsAPI = {
  get(id) {
    return axios.get(`${flowSessionsClient.url}/${id}`);
  },

  getByConversation(conversationId) {
    return axios.get(`${flowSessionsClient.url}/conversation_session`, {
      params: { conversation_id: conversationId },
    });
  },

  pause(id) {
    return axios.post(`${flowSessionsClient.url}/${id}/pause`);
  },

  resume(id) {
    return axios.post(`${flowSessionsClient.url}/${id}/resume`);
  },

  stop(id) {
    return axios.post(`${flowSessionsClient.url}/${id}/stop`);
  },
};
